<div class="db-ecommerce-emails__content-header">
  <div>
    <h1>{{ 'text_emailSettings' | dbText }}</h1>
    <p class="mt4" [innerHTML]="'text_enhanceYourEmailsWithYourBrandsIdentity' | dbText"></p>
  </div>
  <button class="ds-btn-black" [disabled]="loading || disabledBtn" (click)="saveSettings()">
    <span *ngIf="!loading">{{ 'text_saveChanges' | dbText }}</span>
    <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
  </button>
</div>
<div class="db-ecommerce-emails-settings__content mt30" [formGroup]="emailsSettingsForm">
  <div class="db-ecommerce-emails-settings__email-info">
    <div>
      <h1>
        <span [innerHTML]="settings?.fromName?.label"></span>
        <i class="db-icon db-icon-info-lined ml5"
           [dsTooltip]="settings?.fromName?.tip" [dsTooltipColor]="'black'"
           [hostClass]="'cover-all'"
           dsTooltipPosition="right"
           dsTooltipAlign="center"></i>
      </h1>
      <div class="ds-input-wrap mt20">
        <input type="text" class="ds-input"
               [value]="settings?.fromName?.value"
               [placeholder]="settings?.fromName?.value"
               [formControlName]="settings?.fromName?.id">
      </div>
    </div>
    <div>
      <h1>
        <span [innerHTML]="settings?.fromAddress?.label"></span>
        <i class="db-icon db-icon-info-lined ml5"
           [dsTooltip]="settings?.fromAddress?.tip" [dsTooltipColor]="'black'"
           [hostClass]="'cover-all'"
           dsTooltipPosition="right"
           dsTooltipAlign="center"></i>
      </h1>
      <div class="ds-input-wrap mt20">
        <input type="text" class="ds-input"
               [value]="settings?.fromAddress?.value"
               [placeholder]="settings?.fromAddress?.value"
               [formControlName]="settings?.fromAddress?.id">
      </div>
    </div>
  </div>

  <div class="db-ecommerce-emails-settings__footer">
    <h1>
      <span [innerHTML]="settings?.footerText?.label"></span>
      <i class="db-icon db-icon-info-lined ml5"
         [dsTooltip]="settings?.footerText?.tip" [dsTooltipColor]="'black'"
         [hostClass]="'cover-all'"
         dsTooltipPosition="right"
         dsTooltipAlign="center"></i>
    </h1>
    <div class="ds-input-wrap mt20">
      <textarea class="ds-textarea"
                [value]="settings?.footerText?.value"
                [placeholder]="settings?.footerText?.value"
                [formControlName]="settings?.footerText?.id"
      ></textarea>
    </div>
  </div>

  <div class="db-ecommerce-emails-settings__colors">
    <div>
      <div class="db-ecommerce-emails-settings__color-item">
        <div>
          <h2 [innerHTML]="settings?.primaryColor?.label"></h2>
          <p class="mt4" [innerHTML]="settings?.primaryColor?.description"></p>
        </div>
        <div class="db-ecommerce-emails-settings__color-picker" *ngIf="settings?.primaryColor?.value">
          <input class="db-ecommerce-emails-settings__color"
                 [style.background]="primaryColor"
                 [colorPicker]="primaryColor"
                 (colorPickerChange)="disabledBtn = false;primaryColor = $event" />
          <input class="db-ecommerce-emails-settings__color-value"
                 [colorPicker]="primaryColor"
                 (colorPickerChange)="disabledBtn = false;primaryColor = $event"
                 [value]="primaryColor || settings?.primaryColor?.value"
                 [placeholder]="primaryColor || settings?.primaryColor?.value"
                 [formControlName]="settings?.primaryColor?.id"
          />
        </div>
      </div>

      <div class="db-ecommerce-emails-settings__color-item">
        <div>
          <h2 [innerHTML]="settings?.bgColor?.label"></h2>
          <p class="mt4" [innerHTML]="settings?.bgColor?.description"></p>
        </div>
        <div class="db-ecommerce-emails-settings__color-picker" *ngIf="settings?.bgColor?.value">
          <input class="db-ecommerce-emails-settings__color"
                 [style.background]="bgColor"
                 [colorPicker]="bgColor"
                 (colorPickerChange)="disabledBtn = false;bgColor = $event" />
          <input class="db-ecommerce-emails-settings__color-value"
                 [colorPicker]="bgColor"
                 (colorPickerChange)="disabledBtn = false;bgColor = $event"
                 [value]="bgColor || settings?.bgColor?.value"
                 [placeholder]="bgColor || settings?.bgColor?.value"
                 [formControlName]="settings?.bgColor?.id"/>
        </div>
      </div>
    </div>

    <div class="mt20">
      <div class="db-ecommerce-emails-settings__color-item">
        <div>
          <h2 [innerHTML]="settings?.bodyBgColor?.label"></h2>
          <p class="mt4" [innerHTML]="settings?.bodyBgColor?.description"></p>
        </div>
        <div class="db-ecommerce-emails-settings__color-picker" *ngIf="settings?.bodyBgColor?.value">
          <input class="db-ecommerce-emails-settings__color"
                 [style.background]="bodyBgColor"
                 [colorPicker]="bodyBgColor"
                 (colorPickerChange)="disabledBtn = false;bodyBgColor = $event" />
          <input class="db-ecommerce-emails-settings__color-value"
                 [colorPicker]="bodyBgColor"
                 (colorPickerChange)="disabledBtn = false;bodyBgColor = $event"
                 [value]="bodyBgColor || settings?.bodyBgColor?.value"
                 [placeholder]="bodyBgColor || settings?.bodyBgColor?.value"
                 [formControlName]="settings?.bodyBgColor?.id"/>
        </div>
      </div>


      <div class="db-ecommerce-emails-settings__color-item">
        <div>
          <h2 [innerHTML]="settings?.textColor?.label"></h2>
          <p class="mt4" [innerHTML]="settings?.textColor?.description"></p>
        </div>
        <div class="db-ecommerce-emails-settings__color-picker" *ngIf="settings?.textColor?.value">
          <input class="db-ecommerce-emails-settings__color"
                 [style.background]="textColor"
                 [colorPicker]="textColor"
                 (colorPickerChange)="disabledBtn = false;textColor = $event" />
          <input class="db-ecommerce-emails-settings__color-value"
                 [colorPicker]="textColor"
                 (colorPickerChange)="disabledBtn = false;textColor = $event"
                 [value]="textColor || settings?.textColor?.value"
                 [placeholder]="textColor || settings?.textColor?.value"
                 [formControlName]="settings?.textColor?.id" />
        </div>
      </div>
    </div>
    <div class="mt30 preview-email">
      <a dbWpLink [adminLink]="website?.adminEcommerceEmailPreviewUrl" [websiteId]="website?.id" target="_blank" rel="noopener">{{ 'text_previewYourEmailTemplate' | dbText }}</a>
    </div>
  </div>
</div>
<db-loading-screen *ngIf="loading" [pageBlocker]="true"></db-loading-screen>

